import React from 'react';
import Header from "./common/Header";
import './OrderContract.css';

const OrderContract = () => {
    return (
        <>
            <Header />
            <div className="order-contract">
                <div style={{marginLeft: '0'}}>
                    <h1>Публичная оферта</h1>

                    <h2>Основные понятия</h2>
                    <ul>
                        <li><strong>Посетитель Сайта</strong> — лицо, пришедшее на Сайт без цели оформления Заказа.</li>
                        <li><strong>Пользователь</strong> — физическое лицо, посетитель Сайта, принимающий условия
                            настоящего Соглашения и желающий оформить Заказы в Интернет-магазине zametna.com.
                        </li>
                        <li><strong>Покупатель</strong> — Потребитель, Получатель заказа, Пользователь, оформивший Заказ
                            в
                            Интернет-магазине zametna.com.
                        </li>
                        <li><strong>Получатель заказа</strong> – Покупатель/Лицо, уполномоченное Покупателем на
                            получение
                            Заказа.
                        </li>
                        <li><strong>Интернет-магазин / Интернет-магазин zametna.com</strong> — Сайт, являющийся
                            агрегатором
                            информации о Товарах (услугах), принадлежащий zametna, где представлены Товары, предлагаемые
                            Продавцами для приобретения, а также условия оплаты и доставки Товаров Покупателям.
                        </li>
                        <li><strong>Продавец</strong> — zametna (общество с ограниченной ответственностью «Рэвл», ОГРН
                            1255000030174, ИНН 5074093746, КПП 507401001, место нахождения:
                            142105, РОССИЯ, МОСКОВСКАЯ ОБЛАСТЬ, Г.О. ПОДОЛЬСК, Г ПОДОЛЬСК, УЛ ЛИТЕЙНАЯ, Д. 42А, КВ. 133
                            или иное юридическое лицо либо
                            индивидуальный предприниматель, информация о которых размещается на Странице Продавцов,
                            Товары
                            которых размещены в Интернет-магазине.
                        </li>
                        <li><strong>Агрегатор информации о Товарах (услугах)</strong> — Сайт, на котором потребителю
                            представлена в отношении определенного Товара возможность одновременно ознакомиться с
                            предложением продавца о заключении договора купли-продажи Товара, заключить с продавцом
                            договор
                            купли-продажи, а также произвести предварительную оплату указанного Товара путем перевода
                            денежных средств владельцу агрегатора (zametna) в рамках применяемых форм безналичных
                            расчетов.
                        </li>
                        <li><strong>Сайт</strong> — http://zametna.com и мобильные приложения zametna для операционных
                            систем iOS и Android.
                        </li>
                        <li><strong>Учетная запись/Аккаунт</strong> – страница Пользователя / Покупателя, доступная
                            после
                            прохождения процедуры регистрации на Сайте / в официальном мобильном приложении zametna,
                            содержащая персональные данные и доступ к которой осуществляется с использованием логина и
                            пароля, либо с использованием номера телефона и направленного на него кода для входа, равно
                            как
                            и доступная с помощью авторизации через иные поддерживаемые Сайтом / приложением сервисы.
                            Действия, совершенные через Аккаунт, считаются совершенными Пользователем / Покупателем, чьи
                            персональные данные указаны в Аккаунте.
                        </li>
                        <li><strong>Страница Продавца</strong> — страница Сайта, содержащая сведения об условиях
                            продажи,
                            доставки и возврата Товаров, реализуемых Продавцами, отличными от zametna, а также иную
                            информацию, являющуюся существенной для заключения и исполнения договора купли-продажи
                            Товара.
                            Страница Продавца доступна по ссылке, размещенной на странице с описанием Товара.
                        </li>
                        <li><strong>Товар</strong> — обувь, одежда, аксессуары и иные товары, представленные к продаже
                            на
                            Сайте.
                        </li>
                        <li><strong>Оформление заказа</strong> — должным образом оформленный запрос Покупателя на
                            приобретение и доставку по указанному Покупателем адресу / посредством самовывоза Товаров,
                            выбранных на Сайте.
                        </li>
                        <li><strong>Торговый представитель</strong> – лицо, уполномоченное Продавцом на выдачу Заказа
                            Покупателю на принятие оплаты и на выполнение всех обязанностей Продавца в целях исполнения
                            договора.
                        </li>
                        <li><strong>Способ доставки</strong> – выбранный потребителем метод получения заказа.</li>
                    </ul>

                    <h2>Общие положения</h2>
                    <ul>
                        <li>Продавец осуществляет продажу Товаров через Интернет-магазин по адресу <a
                            href="http://www.zametna.com" target="_blank"
                            rel="noreferrer">http://www.zametna.com</a> или
                            через мобильные приложения zametna для iOS и Android.
                        </li>
                        <li>При регистрации или оформлении заказа на сайте или в приложении Пользователь / Посетитель
                            соглашается с условиями настоящего Соглашения. В отношении Товаров, реализуемых не zametna,
                            но
                            иными продавцами — также с условиями на их страницах. В случае несогласия Пользователь
                            обязан
                            немедленно прекратить использование сервиса.
                        </li>
                        <li>Условия продажи Товаров и информация о Товаре на Сайте являются публичной офертой (ст. 435,
                            п. 2
                            ст. 437 ГК РФ), если иное не указано.
                        </li>
                        <li>zametna может изменить Соглашение в одностороннем порядке. Новая редакция вступает в силу на
                            следующий день после публикации на Сайте и/или в приложении.
                        </li>
                        <li>Соглашение считается принятым с момента регистрации, оформления заказа, либо любого
                            действия,
                            выражающего намерение оформить заказ.
                        </li>
                        <li>Сообщая zametna свой e-mail или номер телефона, Пользователь дает согласие на их
                            использование
                            zametna и третьими лицами для связи, информирования, доставки и исполнения обязательств.
                        </li>
                        <li>Оформляя Заказ, Пользователь соглашается, что Продавец может поручить его исполнение третьим
                            лицам, оставаясь ответственным за результат.
                        </li>
                        <li>Все права и обязанности возникают у Продавца. При договоре с другим Продавцом zametna не
                            является его стороной и не несет обязанностей, кроме прямо предусмотренных Соглашением.
                        </li>
                        <li>zametna предоставляет информационное сопровождение заключенного договора.</li>
                        <li>Заказ в zametna.com можно оформить круглосуточно, кроме времени технических сбоев или работ.
                        </li>
                        <li>Возврат осуществляется с помощью оформления заявки в разделе "Возвраты" или через службу
                            поддержки.
                        </li>
                        <li>Отношения регулируются Законом РФ «О защите прав потребителей», ГК РФ, Постановлениями
                            Правительства № 2463 и № 924.
                        </li>
                        <li>Местом заключения и исполнения договора является юридический адрес ООО «Рэвл».</li>
                    </ul>

                    <h2>Предмет соглашения</h2>
                    <ul>
                        <li>Предметом настоящего Соглашения является предоставление Пользователю возможности приобретать
                            для
                            личных, семейных, домашних и иных нужд, не связанных с предпринимательской деятельностью,
                            Товары, представленные в каталоге Интернет-магазина, а также Электронные Подарочные
                            Сертификаты
                            (за исключением процедуры их приобретения), представленные по адресу <a
                                href="https://www.zametna.com/giftcertificate/" target="_blank"
                                rel="noreferrer">https://www.zametna.com/giftcertificate/</a>.
                        </li>
                        <li>В случае оформления заказа Пользователем с целью ведения предпринимательской деятельности,
                            либо
                            при наличии у Продавца обоснованных сомнений в обратном, положения Закона о защите прав
                            потребителей к таким отношениям не применяются.
                        </li>
                        <li>Настоящее Соглашение распространяется на все виды Товаров и услуг, представленных на Сайте,
                            пока
                            предложения находятся в ассортименте Интернет-магазина.
                        </li>
                        <li>Договор розничной купли-продажи считается заключённым с момента выдачи Продавцом кассового
                            или
                            товарного чека Покупателю.
                        </li>
                        <li>При выборе способа оплаты «При получении» (с примеркой или без) общее количество товаров в
                            заказе для каждой из следующих категорий не должно превышать 4 единиц: Верхняя одежда, Низ,
                            Верх, Платья и костюмы, Обувь, Сумки, Аксессуары, Нижнее бельё. Эти ограничения учитывают
                            товары, находящиеся в пути.
                        </li>
                        <li>Товарами «в пути» считаются позиции, по которым оформлен заказ и которые находятся в
                            процессе
                            доставки. Онлайн-оплаченные товары не входят в этот список.
                        </li>
                        <li>Ограничения для оплаты «Онлайн» не действуют.</li>
                        <li>Количество доступных товаров для «При получении» может увеличиваться по правилам программы
                            лояльности.
                        </li>
                        <li>Для новых Пользователей (без оформленных заказов ранее) первые 3 заказа могут включать до 10
                            товаров из категорий: Верхняя одежда, Низ, Верх, Платья и костюмы, Обувь, Сумки, Аксессуары,
                            Нижнее бельё.
                        </li>
                    </ul>

                    <h2>Регистрация на сайте</h2>
                    <ul>
                        <li>Регистрация на Сайте осуществляется через всплывающее окно «Регистрация».</li>
                        <li>zametna не несет ответственности за точность и корректность данных, предоставляемых
                            Пользователем при регистрации.
                        </li>
                        <li>Пользователь обязуется не передавать логин и пароль третьим лицам. При подозрении на их
                            компрометацию Пользователь должен немедленно уведомить службу поддержки zametna, При
                            отсутствии уведомления передача
                            данных считается добровольной.
                        </li>
                        <li>В случае передачи учетной записи или утечки данных, сделанной по вине Пользователя, все
                            риски и
                            обязательства, связанные с действиями третьих лиц, переходят на него.
                        </li>
                        <li>Фактом передачи учетной записи считается получение третьим лицом информации для входа.</li>
                        <li>zametna не несет ответственности за действия третьих лиц, причинившие ущерб с использованием
                            учетной записи Пользователя.
                        </li>
                        <li>Общение Пользователя с представителями zametna или иных Продавцов должно соответствовать
                            нормам
                            морали и этики. Запрещено использование брани, оскорблений, угроз, проявлений дискриминации.
                        </li>
                        <li>При агрессивном или хулиганском поведении в звонке на call-центр zametna, Продавец вправе
                            перевести взаимодействие в письменную форму.
                        </li>
                        <li>При аналогичных действиях в чатах/мессенджерах Продавец вправе продолжать общение только
                            через
                            Почту России, игнорируя иные каналы, но с возможностью отвечать по e-mail.
                        </li>
                    </ul>

                    <h2>Товар и порядок совершения покупки</h2>
                    <ul>
                        <li>В случае отсутствия заказанных Товаров на складе Продавца, zametna уведомляет Покупателя по
                            e-mail или телефону, предлагая альтернативы либо аннулирование заказа (полное или
                            частичное).
                        </li>
                        <li>При аннуляции предоплаченного заказа, стоимость аннулированного Товара возвращается тем же
                            способом оплаты.
                        </li>
                        <li>Если оператор не свяжется с Покупателем в течение 24 часов после оформления, либо Заказ не
                            подтверждается более 3-х раз, он может быть аннулирован.
                        </li>
                        <li>Покупатель несет ответственность за предоставление некорректных данных, повлекших
                            невозможность
                            исполнения заказа.
                        </li>
                        <li>После оформления Заказа Покупателю сообщается дата доставки по e-mail или телефону.
                            Представитель zametna согласует детали и время доставки.
                        </li>
                        <li>В день доставки представитель связывается с Покупателем. При отсутствии связи и
                            несогласовании
                            нового времени заказ считается отклоненным.
                        </li>
                        <li>Некоторые категории товаров (например, нижнее белье, косметика) не подлежат дистанционной
                            продаже и требуют отдельного согласования.
                        </li>
                        <li>Типовые свойства товара не считаются недостатками (морщинистость кожи, незначительные следы
                            клея, неравномерная строчка и т.п.).
                        </li>
                        <li>Заказ может быть признан несовершенным при отсутствии обязательной маркировки, техническом
                            сбое
                            в расчетах или отсутствии товара на складе.
                        </li>
                    </ul>

                    <h2>Доставка заказа</h2>
                    <ul>
                        {/*<li>Информация о доставке размещена на сайте <a*/}
                        {/*    href="https://www.zametna.com/about/shipping">zametna.com/about/shipping</a> и страницах*/}
                        {/*    Продавцов.*/}
                        {/*</li>*/}
                        <li>Доставка возможна в пределах РФ. Если адрес вне зоны доставки — возможен перенос заказа на
                            ближайший доступный адрес.
                        </li>
                        <li>В случае агрессивного поведения при доставке zametna вправе перевести клиента на самовывоз
                            или
                            доставку Почтой России.
                        </li>
                        <li>Заказ может быть выдан Покупателю, Получателю или лицу, предоставившему необходимые данные
                            (номер заказа, ФИО и т.п.).
                        </li>
                        <li>При вручении предоплаченного заказа представитель вправе запросить документ, удостоверяющий
                            личность.
                        </li>
                        <li>Проверка внешнего вида и комплектности заказа осуществляется в присутствии торгового
                            представителя.
                        </li>
                        <li>Примерка доступна до 10 вещей при присутствии представителя. Без представителя — до 3 вещей
                            единовременно.
                        </li>
                        <li>Некоторые товары (например, купальники) не подлежат примерке до выкупа.</li>
                        <li>Время нахождения представителя при доставке ограничено 15 минутами.</li>
                        <li>Стоимость доставки рассчитывается индивидуально и указывается на последнем этапе оформления.
                        </li>
                        <li>Риск случайной гибели Товара переходит Покупателю с момента его передачи.</li>
                        <li>При доставке Почтой России вскрытие посылки должно производиться в присутствии сотрудника
                            почты.
                        </li>
                        <li>При получении через постамат — вскрытие должно быть произведено под камерой, претензии
                            направляются на claims@zametna.com.
                        </li>
                        <li>Если товар не принят по вине Покупателя, повторная доставка возможна после оплаты новой
                            доставки.
                        </li>
                    </ul>

                    <h2>Оплата товара</h2>
                    <ul>
                        <li>Цена Товара, реализуемого в Интернет-магазине, указывается в
                            рублях Российской Федерации и включает в себя налог на добавленную стоимость в случае, если
                            соответствующий Продавец применяет общую систему налогообложения.
                        </li>
                        <li>Цена Товара на Сайте может быть изменена Продавцом в одностороннем порядке. При этом цена на
                            заказанный Покупателем Товар изменению не подлежит. Цена Товара может дифференцироваться по
                            регионам в зависимости от экономических показателей. Цена Товара, реализуемого в
                            Интернет-магазине, может отличаться.
                        </li>
                        <li>Особенности оплаты Товара с помощью банковских карт:
                            <ul>
                                <li>В соответствии с положением ЦБ РФ «Об эмиссии банковских карт и об операциях,
                                    совершаемых с использованием платежных карт» от 24.12.2004 № 266-П операции по
                                    банковским картам совершаются держателем карты либо уполномоченным им лицом.
                                </li>
                                <li>Авторизация операций по банковским картам осуществляется банком. Если у банка есть
                                    основания полагать, что операция носит мошеннический характер, то банк вправе
                                    отказать в
                                    осуществлении данной операции. Мошеннические операции с банковскими картами попадают
                                    под
                                    действие статьи 159 УК РФ.
                                </li>
                                <li>Во избежание случаев различного рода неправомерного использования банковских карт
                                    при
                                    оплате все Заказы, оформленные на Сайте и предоплаченные банковской картой,
                                    проверяются
                                    zametna. В целях проверки личности владельца и его правомочности на использование
                                    карты
                                    zametna вправе потребовать от Покупателя, оформившего такой заказ, предъявления
                                    документа, удостоверяющего личность.
                                </li>
                            </ul>
                        </li>
                        <li>При предоплате заказа (способом курьерской доставки) банковской картой на сайте или через
                            мобильное приложение, денежные средства блокируются на карте до момента выкупа товара.
                        </li>
                        <li>В момент получения заказа и при полном выкупе всех товаров, денежные средства за заказ
                            списываются со счета.
                        </li>
                        <li>При частичном выкупе товаров из заказа, операция о списании денежных средств в день
                            оформления
                            заказа уменьшится на сумму, равную стоимости невыкупленных товаров.
                        </li>
                        <li>При полном отказе от заказа, операция о списании денежных средств в день оформления заказа
                            будет
                            удалена из истории операций.
                        </li>
                        <li>При холдировании денежные средства не поступают Продавцу и их разблокировку осуществляет
                            банк.
                        </li>
                        <li>zametna предоставляет Пользователю возможность сохранить данные одной или нескольких
                            банковских
                            карт в своем Аккаунте или реквизиты иных способов платежей.
                        </li>
                        <li>Пользователь имеет возможность отвязать привязанный ранее способ платежа от своего Аккаунта
                            при
                            помощи функционала Сайта.
                        </li>
                        <li>Пользователь гарантирует, что он является владельцем банковской карты или правомерным
                            пользователем иного средства платежа.
                        </li>
                        <li>zametna и иные Продавцы вправе предоставлять скидки на Товары и устанавливать программу
                            бонусов .
                        </li>
                        <li>Стоимостью заказа является стоимость, указанная на сайте, с учетом всех скидок.</li>
                        <li>При проведении маркетинговых мероприятий, предполагающих вложение каких-либо объектов в
                            отправления с Заказом Покупателя, доставка указанных вложений осуществляется за счет
                            Покупателя.
                        </li>
                        <li>Заказ считается неукомплектованным, если Покупатель сообщил об изменении решения о покупке
                            до
                            момента передачи заказа в доставку.
                        </li>
                        <li>zametna вправе принять решение о блокировке для Покупателя способа оплаты «При получении» в
                            ряде
                            случаев, включая низкий процент выкупа, подозрения в мошенничестве и др.
                        </li>
                        <li>Иные Продавцы вправе устанавливать доступные Покупателю способы оплаты по своему усмотрению.
                        </li>
                        <li>При оплате товара Покупателю направляется чек в электронной форме на адрес электронной
                            почты,
                            указанной в личном кабинете zametna.
                        </li>
                    </ul>

                    <h2>Возврат товара и денежных средств</h2>

                    <h3>Общие положения о возврате</h3>
                    <ul>
                        <li>Возврат Товара, реализуемого zametna, осуществляется в соответствии с «Условиями возврата»,
                            указанными на Сайте по адресу https://zametna.com/easy-return. Правила возврата Товара
                            могут устанавливаться каждым соответствующим Продавцом самостоятельно и публикуются на
                            Странице
                            соответствующего Продавца.
                        </li>
                        <li>Для рассмотрения заявки на возврат необходимо заполнить онлайн-заявление на возврат, а также
                            выслать товар, товарный чек, копию описи Отправления на адрес: 142105, РОССИЯ, МОСКОВСКАЯ
                            ОБЛАСТЬ, Г.О. ПОДОЛЬСК, Г ПОДОЛЬСК, УЛ ЛИТЕЙНАЯ, Д. 42А, КВ. 133 ООО "Рэвл"
                        </li>
                        <li>Направление или предъявление заявлений, претензий по адресам Пунктов выдачи заказов и/или
                            иным
                            Торговым представителям zametna на руки не является надлежащим способом их направления.
                            Продавец
                            вправе не рассматривать такие претензии.
                        </li>
                        <li>Возврат, доставленного посредством Почты России Товара с претензией осуществляется по
                            вышеуказанному адресу.
                        </li>
                        <li>Способы возврата Товара:
                            <ul>
                                <li>а) Склад zametna в Москве: возврат бесплатный;
                                </li>
                                <li>б) Почта России: возврат осуществляется вне зависимости от способа получения заказа.
                                </li>
                            </ul>
                        </li>
                        <li>В случае злоупотребления правом zametna вправе перевести Покупателя на возврат только Почтой
                            России без объяснения причин.
                        </li>
                        <li>При наличии подозрений в действиях, направленных на финансовую выгоду без цели личного
                            использования, возврат возможен только на тот же счет, с которого производилась предоплата.
                        </li>
                        <li>Невостребованный возвращённый товар хранится 6 месяцев, после чего утилизируется.</li>
                    </ul>

                    <h3>Возврат Товара надлежащего качества</h3>
                    <ul>
                        <li>Покупатель вправе отказаться от товара в течение 14 календарных дней после его получения.
                        </li>
                        <li>Товар должен сохранять товарный вид и потребительские свойства.</li>
                        <li>Возврат средств происходит после проверки сохранности товарного вида.</li>
                        <li>Продавец возвращает стоимость товара за вычетом расходов на доставку в течение 10 дней после
                            получения товара на склад.
                        </li>
                    </ul>

                    <h3>Возврат Товара ненадлежащего качества</h3>
                    <ul>
                        <li>Если товар неисправен и это не было заранее указано, Покупатель вправе воспользоваться
                            положениями ст. 18 Закона РФ «О защите прав потребителей».
                        </li>
                        <li>Покупатель обязан предоставить товар Продавцу одним из доступных способов.</li>
                        <li>Продавец обязан принять товар, при необходимости провести проверку качества и, в случае
                            спора,
                            экспертизу за свой счёт.
                        </li>
                        <li>После экспертизы товар возвращается Покупателю, если адрес не указан или нет ответа,
                            Продавец
                            распоряжается товаром самостоятельно.
                        </li>
                        <li>Возврат средств осуществляется в течение 10 дней после предъявления требования и возврата
                            товара.
                        </li>
                        <li>Возврат осуществляется на карту, с которой была произведена оплата, почтовым переводом или
                            наличными.
                        </li>
                    </ul>

                    <h3>Возврат технически сложного Товара</h3>
                    <ul>
                        <li>Возврат осуществляется по перечню из Постановления Правительства РФ от 10.11.2011 № 924.
                        </li>
                        <li>Товары с заводской упаковкой проверяются без вскрытия.</li>
                        <li>Товары без упаковки проверяются визуально на дефекты.</li>
                    </ul>

                    <h2>Гарантийный срок</h2>
                    <ul>
                        <li>В пределах гарантийного срока Покупатель вправе по своему выбору обратиться с требованием о
                            возврате Товара ненадлежащего качества к изготовителю, продавцу или импортеру.
                        </li>
                        <li>Гарантийный срок на одежду, обувь и иную продукцию, если иное не установлено изготовителем,
                            составляет 30 (тридцать) календарных дней с момента покупки.
                        </li>
                        <li>Гарантийный срок, установленный изготовителем, указан в описании к Товару. Если гарантийный
                            срок
                            изготовителя составляет более 30 дней, применяется он.
                        </li>
                        <li>Если гарантийный срок составляет менее двух лет и недостатки товара обнаружены по истечении
                            гарантийного срока, но в пределах двух лет, Покупатель вправе предъявить Продавцу
                            требования,
                            если он докажет, что недостатки возникли до передачи товара.
                        </li>
                        <li>Если существенный недостаток товара выявлен по истечении 2 лет и истек гарантийный срок,
                            требование может быть заявлено только к изготовителю при наличии доказательств.
                        </li>
                    </ul>

                    <h2>Ответственность</h2>
                    <ul>
                        <li>Продавец не несет ответственности за ущерб, причиненный Покупателю вследствие ненадлежащего
                            использования Товаров.
                        </li>
                        <li>Продавец не несет ответственности за содержание и функционирование внешних сайтов.</li>
                        <li>Zametna не несет ответственности за качество Товара, реализуемого иными Продавцами.</li>
                        <li>Претензии по качеству и количеству Товара направляются соответствующему Продавцу.</li>
                        <li>Zametna оказывает содействие в разрешении претензий, предоставляя необходимую информацию.
                        </li>
                        <li>Ответственность за исполнение договора и соблюдение прав потребителей несет Продавец.</li>
                    </ul>

                    <h2>Конфиденциальность и защита информации</h2>
                    <ul>
                        <li>Персональные данные обрабатываются в соответствии с ФЗ №152-ФЗ «О персональных данных».</li>
                        <li>При регистрации предоставляются: ФИО, телефон, e-mail, дата рождения, пол, адрес и фото.
                        </li>
                        <li>Пользователь соглашается на использование изображения и несет за него ответственность.</li>
                        <li>Zametna вправе отказать в размещении изображения по моральным или юридическим основаниям.
                        </li>
                        <li>Пользователь соглашается на обработку данных в целях исполнения обязательств, обратной
                            связи,
                            маркетинга и аналитики.
                        </li>
                        <li>Обработка включает сбор, хранение, уточнение, использование, передачу, удаление персональных
                            данных.
                        </li>
                        <li>Zametna может отправлять информационные и рекламные сообщения с согласия Пользователя.</li>
                        <li>Отказ от получения рекламы возможен путем направления письма на help@zametna.com.</li>
                        <li>Сервисные сообщения обрабатываются автоматически и не подлежат отказу.</li>
                        <li>Отзыв согласия осуществляется через форму, размещённую на сайте.</li>
                        <li>Zametna использует cookies и IP-адреса в аналитических целях, но не для установления
                            личности.
                        </li>
                        <li>Ответственность за публичные данные несет Пользователь.</li>
                        <li>Телефонные разговоры могут записываться для улучшения сервиса.</li>
                        <li>Zametna применяет Google Analytics, Яндекс Метрика и Yandex SmartCaptcha для анализа и
                            защиты.
                        </li>
                    </ul>

                    <h2>Срок действия Публичной оферты</h2>
                    <ul>
                        <li>Настоящее Соглашение вступает в силу с момента её акцепта Посетителем Сайта/Покупателем и
                            действует до момента отзыва акцепта либо фактического исполнения.
                        </li>
                    </ul>

                    <h2>Дополнительные условия</h2>
                    <ul>
                        <li>Продавец вправе переуступать свои права и обязанности третьим лицам.</li>
                        <li>Сайт может быть временно недоступен по техническим причинам.</li>
                        <li>Для следующих случаев требуется предварительное согласование условий покупки:
                            <ul>
                                <li>возврат/невыкуп/отмена >70% товаров;</li>
                                <li>подмена товара;</li>
                                <li>использование >5 карт для оплаты/возврата;</li>
                                <li>использование разных e-mail/телефонов;</li>
                                <li>оформление заказов не для личного пользования;</li>
                                <li>нарушение порядка возврата;</li>
                                <li>отмена >80% заказов;</li>
                                <li>процент выкупа 20%;</li>
                                <li>использование карт для кешбека.</li>
                            </ul>
                        </li>
                        <li>Взаимоотношения регулируются законодательством РФ.</li>
                        <li>Споры решаются Продавцом по контактам, указанным на сайте.</li>
                        <li>Недействительность одного пункта не влияет на остальные.</li>
                    </ul>

                    <h2>Находки</h2>
                    <ul>
                        <li>Если забытая вещь не востребована в течение 7 дней, zametna вправе её утилизировать или
                            передать
                            в полицию.
                        </li>
                    </ul>

                    <h2>Рекомендательные технологии</h2>
                    <ul>
                        <li>zametna предлагает рекомендации на основе:
                            <ul>
                                <li>действий пользователя на сайте,</li>
                                <li>геолокации,</li>
                                <li>модели устройства и заказов.</li>
                            </ul>
                        </li>
                        <li>Неперсонализированные рекомендации формируются на основе статистики.</li>
                        <li>Данные передаются на серверы zametna для анализа и формирования рекомендаций.</li>
                        <li>zametna не собирает предпочтения на других сайтах и соблюдает конфиденциальность.</li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default OrderContract;
